import React, { lazy } from "react";

const LazyDataQuery = lazy(() => import("./DataQuery"));

const DataQuery = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyDataQuery {...props} />;

export default DataQuery;
